exports.onClientEntry = () => {
  window.addEventListener("DOMContentLoaded", event => {
    console.log("ready")
  })
}
